<div class="logout-container">
  <h1>Your session has expired. Please login again.</h1>
  <a
    mat-flat-button
    color="primary"
    [routerLink]="['/login']"
    [queryParams]="{ connection: connection }"
    >Login</a
  >
</div>
